module.exports = __webpack_public_path__ + "img/users-light.0857d5e9.svg";